module.exports = __webpack_public_path__ + "static/media/28.2d4ae52b.jpg";